const removeGetParams = (url: string) => {
  const getParamsStartIndex = url.indexOf('?');
  if (getParamsStartIndex < 0) return url;
  return url.substring(0, getParamsStartIndex);
};

export default removeGetParams;
